export default __webpack_public_path__ + "static/media/04.ea6662ac.jpg";